const mediaItems = [
  {
    title: '51吃瓜爆料每日大赛：评委内讧现场实录',
    desc: '独家获取比赛后台争执录音，三位评委因评分标准产生严重分歧',
    duration: '03:25',
    views: '12.8万',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20drama%20scene%20with%20judges%20arguing%2C%20talent%20show%20behind%20scenes%2C%20warm%20dramatic%20lighting%2C%20editorial%20documentary%20style%2C%20professional%20event%20photography%2C%20intense%20confrontation%20atmosphere&width=600&height=340&seq=media-01-51&orientation=landscape',
  },
  {
    title: '电竞转会期：千万合同背后的博弈',
    desc: '深度解析某冠军战队选手转会谈判全过程，涉及多方利益纠葛',
    duration: '05:18',
    views: '9.6万',
    tag: '深度',
    image: 'https://readdy.ai/api/search-image?query=Esports%20contract%20negotiation%20scene%20with%20business%20meeting%20atmosphere%2C%20professional%20office%20setting%2C%20warm%20corporate%20lighting%2C%20editorial%20business%20photography%20style%2C%20serious%20discussion%20composition&width=600&height=340&seq=media-02-51&orientation=landscape',
  },
  {
    title: '娱乐圈大瓜：顶流明星私密对话流出',
    desc: '某当红艺人私下言论遭录音曝光，引发全网热议与粉丝站队',
    duration: '02:47',
    views: '18.3万',
    tag: '热爆',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20news%20theme%20with%20dramatic%20paparazzi%20style%2C%20entertainment%20industry%20atmosphere%2C%20warm%20flash%20photography%20lighting%2C%20editorial%20tabloid%20style%2C%20sensational%20news%20visuals&width=600&height=340&seq=media-03-51&orientation=landscape',
  },
  {
    title: '体育界震撼弹：奥运冠军涉嫌违规',
    desc: '匿名举报材料曝光某奥运冠军涉嫌违规使用训练方法，协会已介入调查',
    duration: '04:12',
    views: '15.7万',
    tag: '重磅',
    image: 'https://readdy.ai/api/search-image?query=Olympic%20stadium%20with%20investigation%20theme%2C%20sports%20authority%20meeting%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20professional%20sports%20journalism%20photography%2C%20serious%20official%20composition&width=600&height=340&seq=media-04-51&orientation=landscape',
  },
  {
    title: '51爆料每日大赛：本周最全爆料速览',
    desc: '五分钟看完本周所有重大赛事爆料，从电竞赛场到体育看台全覆盖',
    duration: '05:00',
    views: '8.2万',
    tag: '速览',
    image: 'https://readdy.ai/api/search-image?query=News%20recap%20montage%20with%20multiple%20sports%20and%20esports%20highlights%2C%20weekly%20roundup%20theme%2C%20warm%20editorial%20collage%20style%2C%20dynamic%20composition%20with%20various%20event%20visuals%2C%20professional%20news%20media%20aesthetic&width=600&height=340&seq=media-05-51&orientation=landscape',
  },
];

export default function MediaCards() {
  return (
    <section id="media" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            爆料视频
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs bg-black/70 text-background-50 px-2 py-0.5 rounded">{item.duration}</span>
                <span className="absolute top-2 left-2 text-xs font-semibold bg-accent-500 text-background-50 px-2 py-0.5 rounded">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-600 mb-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
          {mediaItems.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className={`group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300 transition-colors cursor-pointer ${idx === 0 ? '' : 'hidden sm:block'}`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs bg-black/70 text-background-50 px-2 py-0.5 rounded">{item.duration}</span>
                <span className="absolute top-2 left-2 text-xs font-semibold bg-accent-500 text-background-50 px-2 py-0.5 rounded">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-600 mb-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}